/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ErrorResponse', 'model/GeoResponseLink', 'model/GradeResponse'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./ErrorResponse'), require('./GeoResponseLink'), require('./GradeResponse'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.GradesResponse = factory(root.GisServerApis.ApiClient, root.GisServerApis.ErrorResponse, root.GisServerApis.GeoResponseLink, root.GisServerApis.GradeResponse);
  }
}(this, function(ApiClient, ErrorResponse, GeoResponseLink, GradeResponse) {
  'use strict';




  /**
   * The GradesResponse model module.
   * @module model/GradesResponse
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>GradesResponse</code>.
   * A response includes a collection of grade.
   * @alias module:model/GradesResponse
   * @class
   */
  var exports = function() {
    var _this = this;










  };

  /**
   * Constructs a <code>GradesResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/GradesResponse} obj Optional instance to populate.
   * @return {module:model/GradesResponse} The populated <code>GradesResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('totalCount')) {
        obj['totalCount'] = ApiClient.convertToType(data['totalCount'], 'Number');
      }
      if (data.hasOwnProperty('data')) {
        obj['data'] = ApiClient.convertToType(data['data'], [GradeResponse]);
      }
      if (data.hasOwnProperty('lowestGrade')) {
        obj['lowestGrade'] = ApiClient.convertToType(data['lowestGrade'], 'Number');
      }
      if (data.hasOwnProperty('highestGrade')) {
        obj['highestGrade'] = ApiClient.convertToType(data['highestGrade'], 'Number');
      }
      if (data.hasOwnProperty('averageGrade')) {
        obj['averageGrade'] = ApiClient.convertToType(data['averageGrade'], 'Number');
      }
      if (data.hasOwnProperty('link')) {
        obj['link'] = GeoResponseLink.constructFromObject(data['link']);
      }
      if (data.hasOwnProperty('error')) {
        obj['error'] = ErrorResponse.constructFromObject(data['error']);
      }
      if (data.hasOwnProperty('status')) {
        obj['status'] = ApiClient.convertToType(data['status'], 'String');
      }
      if (data.hasOwnProperty('elapsedTime')) {
        obj['elapsedTime'] = ApiClient.convertToType(data['elapsedTime'], 'String');
      }
    }
    return obj;
  }

  /**
   * The total count of the records.
   * @member {Number} totalCount
   */
  exports.prototype['totalCount'] = undefined;
  /**
   * A collection of grade.
   * @member {Array.<module:model/GradeResponse>} data
   */
  exports.prototype['data'] = undefined;
  /**
   * The lowest value in the collection of response grades.
   * @member {Number} lowestGrade
   */
  exports.prototype['lowestGrade'] = undefined;
  /**
   * The highest value in the collection of response grades.
   * @member {Number} highestGrade
   */
  exports.prototype['highestGrade'] = undefined;
  /**
   * The average value in the collection of response grades.
   * @member {Number} averageGrade
   */
  exports.prototype['averageGrade'] = undefined;
  /**
   * @member {module:model/GeoResponseLink} link
   */
  exports.prototype['link'] = undefined;
  /**
   * @member {module:model/ErrorResponse} error
   */
  exports.prototype['error'] = undefined;
  /**
   * @member {String} status
   */
  exports.prototype['status'] = undefined;
  /**
   * @member {String} elapsedTime
   */
  exports.prototype['elapsedTime'] = undefined;



  return exports;
}));



